import {useCallback, useEffect, useState} from "react";
import {xcService} from "../../../_services/xcService";
import {useTranslation, withTranslation} from "react-i18next";
import {
    DeleteOutlined,
    MoreOutlined,
    FolderOpenOutlined,
    FolderAddOutlined,
    SendOutlined,
    ShareAltOutlined,
    UploadOutlined,QrcodeOutlined,
    LeftOutlined,
    PlusCircleOutlined,
    EditOutlined
} from "@ant-design/icons";
import {Button, Form, Input, Modal, Tag, Upload, message, Popover} from "antd";
import {ShareSocial} from 'react-share-social' 
import config from "_config/config";
import {  isMobile } from 'react-device-detect';
import localOrSessionStore from "../../../_helpers/localOrSessionStore";
import variables from "../../../_constants/variables";

import { QrReader } from 'react-qr-reader';

const ResourceUserView = () => {
    const {t, i18n} = useTranslation();
    const [form] = Form.useForm();
    const [showQr, setShowQr] = useState(false);
    const [messageApi, contextHolder] = message.useMessage();
    const [resourcesData, setResourcesData] = useState();
    const [courseResources, setCourseResources] = useState();
    const [areaResources, setAreaResources] = useState();
    const [studentResources, setStudentResources] = useState();
    const [studentFolders, setStudentFolders] = useState([]);
    const [showCreateFolderModal, setShowCreateFolderModal] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [newFolderName, setNewFolderName] = useState();
    const [currentFolder, setCurrentFolder] = useState();
    const [idFolder, setIdFolder] = useState(null);
    const [regionResources, setRegionResources] = useState();
    const [currentFolderResources, setCurrentFolderResources] = useState([]);
    const [showCreatePrivateResourceModal, setShowCreatePrivateResourceModal] = useState(false);
    const [update, updateState] = useState(null);
    const [pdfLink, setPdfLink] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [link, setLink] = useState("");
    const storage = localOrSessionStore({key: variables.REMEMBER});
    const userType = storage.getItem(variables.USER_TYPE);


    useEffect(() => {
            getData();
            xcService.get('/v1/resources/areas')
                .then(({data}) => setAreaResources(data.data))
            xcService.get('/v1/resources/courses')
                .then(({data}) => setCourseResources(data.data))
            xcService.getToken('/v1/' + (userType === "STUDENT" ? 'student' : 'tutor') + '/folders')
                .then(({data}) => setStudentFolders(data.data))
            xcService.get('/v1/resources/region')
                .then(({data}) => setRegionResources(data.data))
        },
        [update])


    const getData = () => {
        xcService.getToken(userType === "STUDENT" ? '/v1/resources/all' : '/v1/tutor/resources/all')
            .then(({data}) => setResourcesData(data.data))


        xcService.getToken('/v1/' + (userType === "STUDENT" ? 'student' : 'tutor') + '/resources')
            .then(({data}) => {

                    setStudentResources(data.data)
                }
            )
    }

    useEffect(() => {
        xcService.getToken('/v1/' + (userType === "STUDENT" ? 'student' : 'tutor') + '/folders')
            .then(({data}) => setStudentFolders(data.data))
    }, [showCreateFolderModal])

    useEffect(() => {

        getResourcesByFolder();

        },
        [currentFolder])


    const getResourcesByFolder = () => {
        currentFolder && xcService.getToken(`/v1/${userType === "STUDENT" ? 'student' : 'tutor'}/folders/resource/${currentFolder}`)
            .then(({data}) => setCurrentFolderResources(data.data))
    }




    const removeStudentFolder = (id) => {

        xcService.deleteToken(`/v1/${userType === "STUDENT" ? 'student' : 'tutor'}/folders/${id}`)
            .then(({data}) =>

                updateState(Math.random())
            )

    }


    const editStudentFolder = (id, name) => {
        setIdFolder(id);
        setIsEdit(true);
        setNewFolderName(name);
        setShowCreateFolderModal(true);

    }
    const removeStudentResource = (id) => {
        xcService.deleteToken(`/v1/${userType === "STUDENT" ? 'student' : 'tutor'}/resources/${id}`)
            .then(({data}) => setStudentResources(data.data))
    }

    const addResourceToCustomFolder = (folderId, resourceId) => {
        xcService.postToken('/v1/' + (userType === "STUDENT" ? 'student' : 'tutor') + '/folders/resource', {
            folderId, resourceId
        }).then(() => {
            setCurrentFolder(null);
            setIsEdit(false);
            getData();
        })
    }

    const removeResourceFromCurrentFolder = (id) => {
        xcService.deleteToken(`/v1/${userType === "STUDENT" ? 'student' : 'tutor'}/folders/${currentFolder}/resource/${id}`)
            .then(() => {
                    getData();
                    xcService.getToken(`/v1/${userType === "STUDENT" ? 'student' : 'tutor'}/folders/resource/${currentFolder}`)
                        .then(({data}) => setCurrentFolderResources(data.data))
                }
            )
    }


    const createNewFolder = () => {

        if (isEdit) {
            setIsEdit(false);
            if (newFolderName) {
                xcService.putToken(`/v1/${userType === "STUDENT" ? 'student' : 'tutor'}/folders/${idFolder}`, {
                    name: newFolderName
                })
                    .then(() => {
                        setIsEdit(false);
                        setNewFolderName("");
                    })
                    .then(() => setShowCreateFolderModal(false))
            }
        } else {

            setIsEdit(false);
            if (newFolderName) {
                xcService.postToken(`/v1/${userType === "STUDENT" ? 'student' : 'tutor'}/folders`, {
                    name: newFolderName
                })
                    .then(() => {
                        setIsEdit(false);
                        setNewFolderName("");
                    })
                    .then(() => setShowCreateFolderModal(false))
            }
        }
    }

    const createPrivateResource = (values) => {
        xcService.postToken('/v1/resources/' + (userType === "STUDENT" ? '' : 'tutor/') + 'private', {...values})
            .then((data) => {

                setShowCreatePrivateResourceModal(false)
                if (data.data.data.id && currentFolder){
                    let mBody ={
                        folderId: currentFolder,
                            resourceId:data.data.data.id
                    }
                    xcService.postToken('/v1/' + (userType === "STUDENT" ? 'student' : 'tutor') + '/folders/resource', mBody).then(() => {

                        setIsEdit(false);
                        getResourcesByFolder();
                    })

                }
            })
            .then(() => {

                form.resetFields()
                updateState(Math.random())

            })
    }
    const beforeUploadPdf = (file) => {
        const isOk = file.type === "application/pdf" || file.type === 'image/jpeg' || file.type === 'image/png';
        if (!isOk) {
            messageApi.open({
                type: 'error',
                content: 'You can only upload PDF or images files',
              });

        }
        const isLt2M = file.size / 1024 / 1024 < 10;
        if (!isLt2M) {
            messageApi.open({
                type: 'error',
                content: 'Image must smaller than 10MB!',
              });
        }
        return (isOk && isLt2M) || Upload.LIST_IGNORE;
    };


    const handleChangePdf = (info) => {

        if (info.file.status === "uploading") {
            return;
        }
        if (info.file.status === "done") {
            setPdfLink(config.backendUrl + "/v1/download/" + info.file.response);
            const {setFieldsValue, getFieldValue} = form;
            setFieldsValue({
                url: config.backendUrl + "/v1/download/" + info.file.response
            })
        }
        if (info.file.status === "removed") {
            const {setFieldsValue, getFieldValue} = form;
            setPdfLink("");
            setFieldsValue({
                url: ""
            })
        }
    };
    const closeModalCreate = () => {
        setShowCreatePrivateResourceModal(false)
        form.resetFields()
    }
    const handleKeyDown = (event) => {

        if (event.keyCode === 13) {
            createNewFolder()
        }
    }

    const showModal = (link) => {
        setLink(link);
        setIsModalOpen(true);
      };
    
      const handleOk = () => {
        setLink("");
        setIsModalOpen(false);
      };
    
      const handleCancel = () => {
        setLink("")
        setIsModalOpen(false);
      };

      const copyLink = (link) => {
        navigator.clipboard.writeText(link)

          message.success(t("recursocopiado"))
    }

    const copyLinkFromQr = (result) => {
        const {setFieldsValue, getFieldValue} = form;

        setFieldsValue({url: result?.text});


        setShowQr(false);
      };

    return ((resourcesData && studentResources) ?
        !currentFolder ? <>
            {
                <Modal
                    className={"modalName modal-question modal-question--xs modal-custom--xs"}
                    title={isEdit ? t("myFolder.edit") : t("myFolder.titleaddcarpe")}
                    cancelText={t("cancel")}
                    okText={t("save")}
                    onCancel={() => setShowCreateFolderModal(false)}
                    onOk={createNewFolder}
                    open={showCreateFolderModal}
                >
                    <Input onKeyDown={handleKeyDown} placeholder={t("myFolder.carpertan")} value={newFolderName}
                           onChange={({target}) => setNewFolderName(target.value)}></Input>
                </Modal>}
            <Modal
                className={"modalName modal-question modal-question--xs modal-custom--xs"}
                title={t("myFolder.titleaddrec")}
                cancelText={t("cancel")}
                okText={t("save")}

                onCancel={() => closeModalCreate()}
                open={showCreatePrivateResourceModal}
                footer={null}
            >

                <Form
                    className={"form-modal-resources"}
                    form={form}
                    onFinish={createPrivateResource}
                    layout={"vertical"}>
                    <Form.Item name="name" s
                               rules={[{required: true, message: t("mandatory")}]}
                               label={t("myFolder.nombre")}>
                        <Input placeholder={t("myFolder.nombre")}></Input>
                    </Form.Item>
                    <Form.Item name="description" rules={[{required: true, message: t("mandatory")}]}
                               label={t("myFolder.desc")}>
                        <Input placeholder={t("myFolder.desc")}></Input>
                    </Form.Item>

                    {userType === 'ADMIN' &&

                        <Form.Item name="file" label={t("myFolder.upload")}>
                            <Upload
                                beforeUpload={beforeUploadPdf}
                                onChange={handleChangePdf}
                                name="file"
                                maxCount={1}
                                showUploadList={true}
                                action={config.backendUrl + "/v1/uploadfile"}
                            >
                                <Button icon={<UploadOutlined/>}>Upload</Button>
                            </Upload>
                        </Form.Item>
                    }

                    <Form.Item name="url" rules={[{required: true, message: t("mandatory")}]} label="Url">
                        <Input placeholder={t("myFolder.url")}></Input>
                    </Form.Item>
                    {isMobile &&
                                               <>
                                                        <Button type="primary" onClick={() => setShowQr(true)} shape="circle" icon={<QrcodeOutlined />} />
                                                        {showQr &&
                                                            <QrReader
                                                                constraints={{  facingMode: 'environment'}}
                                                                onResult={(result, error) => {
                                                                    if (!!result) {
                                                                        copyLinkFromQr(result)

                                                                    }


                                                                }}
                                                                style={{width: '100%'}}
                                                            />
                                                        }
                                                    </>
                                            }

                    <Form.Item>
                        <Button type="primary" htmlType="submit">
                            {t("myFolder.crear")}
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>
            <div className={"container container--resources boxed boxed--admin-default"}>
                <div className={"header-resources"}>
                    <h1>{t("myFolder.title")}</h1>
                    <Button type="primary"
                            onClick={() => setShowCreatePrivateResourceModal(true)}><PlusCircleOutlined/> {t("myFolder.crear")}
                    </Button>
                </div>
                <div className={"container-resources-folders"} style={{zIndex: 10}}>

                    <Modal title={t("compartirrec")} open={isModalOpen} onOk={handleOk} onCancel={handleCancel}>

                        <ShareSocial
                            url ={link}
                            socialTypes={['facebook','twitter','reddit','linkedin','whatsapp','email']}
                        />
                    </Modal>

                    {resourcesData
                        .filter(resource => studentResources.map(studentResource => studentResource.id).includes(resource.id))
                        .filter(resource => resource?.user_resource_folders && resource?.user_resource_folders.length === 0)
                        .map(resource =>
                            <div className={"card-resources-folders is-resources"} key={resource.id}>
                                <div className={"card-resources-folders-top"}>
                                    <img src={resource.image && resource.image !== "" ? resource.image : "https://dummyimage.com/58x58/000/fff"} alt={""} width={58} height={58}/>
                                    <div className={"card-resources-folders__content"}>
                                        <h3 className={"card-resources-folders__title"}>{resource.name}</h3>
                                        <p className={"card-resources-folders__description"}>{resource.description}</p>
                                        <a className={"card-resources-folders__link"} href={resource.link}
                                           target={"_blank"}>{resource.link}</a>
                                    </div>
                                    <div className={"card-resources-folders__menu"}>
                                        <button className={"card-resources-folders__menu-btn"}><MoreOutlined/></button>
                                        <div className="card-resources-folders__menu-content">
                                            <a href="#"
                                               onClick={() => removeStudentResource(resource.id)}><DeleteOutlined/>{t("resources.menu.remove")}
                                            </a>
                                            <a href="#"
                                               onClick={() => showModal(resource.link)}><ShareAltOutlined/>{t("resources.menu.share")}</a>
                                            {studentFolders.map(folder => <a href="#"
                                                                             onClick={() => addResourceToCustomFolder(folder.id, resource.id)}><FolderAddOutlined/>{t("myFolder.add")} {folder.name}
                                            </a>)}
                                        </div>
                                    </div>
                                </div>
                                <div className={"container-tags"}>
                                    {courseResources.filter(course => course.id === resource.id).map(course =>
                                        <Tag color="magenta">{course.name}</Tag>
                                    )}
                                    {areaResources.filter(area => area.id === resource.id).map(area =>
                                        <Tag color="blue">{area.name}</Tag>
                                    )}
                                    {regionResources.filter(region => region.id === resource.id).map(region =>
                                        <Tag color="red">{region.name}</Tag>
                                    )}
                                </div>
                            </div>
                        )}
                </div>
                <div className={"header-resources"}>
                    <h2>{t("myFolder.micarpertas")}</h2>
                    <Button type="primary"
                            onClick={() => setShowCreateFolderModal(true)}><PlusCircleOutlined/> {t("myFolder.crearc")}
                    </Button>
                </div>
                <div className={"container-resources-folders"}>
                    {studentFolders.map(folder =>
                        <div key={folder.id} className={"card-resources-folders is-folder"}
                        >
                            <FolderOpenOutlined onClick={() => setCurrentFolder(folder.id)}/>
                            <div className={"card-resources-folders__content"}
                                 onClick={() => setCurrentFolder(folder.id)}>
                                <h3 className={"card-resources-folders__title"}>{folder.name}</h3>
                            </div>
                            <div className={"card-resources-folders__menu"} >
                                <button className={"card-resources-folders__menu-btn"}>a<MoreOutlined/></button>
                                <div className="card-resources-folders__menu-content">
                                    <a href="#"
                                       onClick={() => editStudentFolder(folder.id, folder.name)}><EditOutlined/>{t("resources.menu.editfolder")}
                                    </a>
                                    <a href="#"
                                       onClick={() => removeStudentFolder(folder.id)}><DeleteOutlined/>{t("resources.menu.removefolder")}
                                    </a>

                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </> : studentFolders && currentFolderResources &&
            <>

                <Modal
                    className={"modalName modal-question modal-question--xs modal-custom--xs"}
                    title={t("myFolder.titleaddrec")}
                    cancelText={t("cancel")}
                    okText={t("save")}

                    onCancel={() => closeModalCreate()}
                    open={showCreatePrivateResourceModal}
                    footer={null}
                >
                    <Form
                        className={"form-modal-resources"}
                        form={form}
                        onFinish={createPrivateResource}
                        layout={"vertical"}>
                        <Form.Item name="name" s
                                   rules={[{required: true, message: t("mandatory")}]}
                                   label={t("myFolder.nombre")}>
                            <Input placeholder={t("myFolder.nombre")}></Input>
                        </Form.Item>
                        <Form.Item name="description" rules={[{required: true, message: t("mandatory")}]}
                                   label={t("myFolder.desc")}>
                            <Input placeholder={t("myFolder.desc")}></Input>
                        </Form.Item>

                        {userType === 'ADMIN' &&

                            <Form.Item name="file" label={t("myFolder.upload")}>
                                <Upload
                                    beforeUpload={beforeUploadPdf}
                                    onChange={handleChangePdf}
                                    name="file"
                                    maxCount={1}
                                    showUploadList={true}
                                    action={config.backendUrl + "/v1/uploadfile"}
                                >
                                    <Button icon={<UploadOutlined/>}>Upload</Button>
                                </Upload>
                            </Form.Item>
                        }

                        <Form.Item name="url" rules={[{required: true, message: t("mandatory")}]} label="Url">
                            <Input placeholder={t("myFolder.url")}></Input>
                        </Form.Item>
                        {isMobile &&
                            <>
                                <Button type="primary" onClick={() => setShowQr(true)} shape="circle" icon={<QrcodeOutlined />} />
                                {showQr &&
                                    <QrReader
                                        constraints={{  facingMode: 'environment'}}
                                        onResult={(result, error) => {
                                            if (!!result) {
                                                copyLinkFromQr(result)

                                            }


                                        }}
                                        style={{width: '100%'}}
                                    />
                                }
                            </>
                        }

                        <Form.Item>
                            <Button type="primary" htmlType="submit">
                                {t("myFolder.crear")}
                            </Button>
                        </Form.Item>
                    </Form>
                </Modal>
                <div className={"container container--resources boxed boxed--admin-default"}>


                    <a className={"resources-back"}
                       onClick={() => setCurrentFolder(null)}><LeftOutlined/> {t("myFolder.back")}</a>
                    <p></p>
                    <div className={"header-resources"}>
                        <h1>{studentFolders.find(folder => folder.id === currentFolder).name}</h1>
                        <Button type="primary"
                                onClick={() => setShowCreatePrivateResourceModal(true)}><PlusCircleOutlined/> {t("myFolder.crear")}
                        </Button>
                    </div>

                    <Modal title={t("compartirrec")} open={isModalOpen} onOk={handleOk} onCancel={handleCancel}>

                       <ShareSocial 
                               url ={link}
                               socialTypes={['facebook','twitter','reddit','linkedin','whatsapp','email']}
                           />
                   </Modal>
                    <div className={"container-resources-folders"}>
                        {currentFolderResources
                            .map(resource =>
                                <div className={"card-resources-folders is-resources"} key={resource.id}>
                                    <div className={"card-resources-folders-top"}>
                                        <img src={resource.image && resource.image !== "" ? resource.image : "https://dummyimage.com/58x58/000/fff"} alt={""} width={58} height={58}/>

                                        <div className={"card-resources-folders__content"}>
                                            <h3 className={"card-resources-folders__title"}>{resource.name}</h3>
                                            <p className={"card-resources-folders__description"}>{resource.description}</p>
                                            <a className={"card-resources-folders__link"} href={resource.link}
                                               target={"_blank"}>{resource.link}</a>
                                        </div>
                                        <div className={"card-resources-folders__menu"}>
                                            <button className={"card-resources-folders__menu-btn"}><MoreOutlined/>
                                            </button>
                                            <div className="card-resources-folders__menu-content">
                                                <a href="#"
                                                   onClick={() => removeResourceFromCurrentFolder(resource.id)}><FolderAddOutlined/>{t("resources.menu.removeFrom")} {studentFolders.find(folder => folder.id === currentFolder).name}
                                                </a>
                                                <a href="#"  onClick={() => copyLink(resource.link)} ><SendOutlined/>{t("resources.menu.send")}</a>
                                                <a href="#" 
                                                   onClick={() => showModal(resource.link)}><ShareAltOutlined/>{t("resources.menu.share")}</a>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={"container-tags"}>
                                        {courseResources.filter(course => course.id === resource.id).map(course =>
                                            <Tag color="magenta">{course.name}</Tag>
                                        )}
                                        {areaResources.filter(area => area.id === resource.id).map(area =>
                                            <Tag color="blue">{area.name}</Tag>
                                        )}
                                        {regionResources.filter(region => region.id === resource.id).map(region =>
                                            <Tag color="red">{region.name}</Tag>
                                        )}
                                    </div>
                                </div>
                            )}
                    </div>
                </div>

            </>
        : <>Hello</>)
}

export default withTranslation()(ResourceUserView);
